import { z } from 'zod';

import {
  LatestEmployerIndustryType,
  ZodEmployerIndustryTypeV3,
} from '@Common/types/questions/employer_industry';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const EmploymentStatusesValues = [
  'unemployed',
  'employed',
  'student',
  'retired',
  'self_employed',
  'ceo',
] as const;

export const ZodEmploymentStatus = z.enum(EmploymentStatusesValues);
export type EmploymentStatus = z.infer<typeof ZodEmploymentStatus>;

export const ZodEmploymentQuestionnaire = z.object({
  employment_status: ZodEmploymentStatus.nullable(),
  industry_type: ZodEmployerIndustryTypeV3.nullable(),
  job_title: ZodTrimmedString.nullable(),
});
export type EmploymentQuestionnaire = z.infer<typeof ZodEmploymentQuestionnaire>;

export const EmployerIndustryMapping: Record<LatestEmployerIndustryType, string> = {
  accommodation_and_food_services: 'Accommodation & food services',
  accountancy_services: 'Accountancy services',
  administrative_and_support_services: 'Administrative & support services',
  adult_entertainment: 'Adult entertainment',
  agriculture: 'Agriculture',
  arms_defense_and_private_security: 'Arms, defense & private security',
  art_entertainment_and_recreation: 'Art, entertainment & recreation',
  auctions: 'Auctions',
  cbd_business: 'CBD Business',
  construction: 'Construction',
  education: 'Education',
  energy: 'Energy',
  financial_and_insurance_services: 'Financial & insurance services',
  gambling_casinos_and_online_betting: 'Gambling, casinos & online betting',
  health_medicine_and_social_care: 'Health, medicine & social care',
  human_resources_services: 'Human resources services',
  information_and_communication: 'Information & communication',
  legal_and_consulting: 'Legal & consulting',
  manufacturing: 'Manufacturing',
  merchant_services: 'Merchant services',
  mining_and_oil_activities: 'Mining & oil-related activities',
  precious_stones_and_metals: 'Precious stones & metals',
  professional_scientific_and_technical_services: 'Professional, scientific & technical services',
  property: 'Property',
  public_sector: 'Public Sector',
  real_estate_agency_and_renting: 'Real estate agency & renting',
  remittance_and_money_service_business: 'Remittance & money service business',
  retail_services: 'Retail services',
  sects_cults_and_religion: 'Sects, cults & religion',
  supply_chain_management: 'Supply chain management',
  technology_services: 'Technology services',
  tourism_and_travel: 'Tourism & travel',
  trading_unregulated_financial_and_crypto_services:
    'Trading, unregulated financial (holding) & crypto services',
  transport_storage_and_logistics: 'Transport, storage & logistics',
  trust_charities_and_foundations: 'Trust, charities & foundations',
  vehicle_trade_and_repair: 'Vehicle trade & repair',
  water_supply_sewerage_and_waste_management: 'Water supply, sewerage & waste management',
  asset_holding_company: 'Asset holding company',
};
